<button
  class="btn btn-secondary btn-sm py-2 px-3"
  [ngClass]="{ 'disabled cursor-not-allowed': isDisabled }"
  [attr.aria-label]="ariaLabel"
  [attr.disabled]="isDisabled"
  (click)="onClick($event)"
>
  <svg class="icon ml-0 pl-0 left-0 icon-sm download-icon"></svg>
  <span class="pl-0 pr-1 py-1 text-color-white"> {{ label }}</span>
</button>
